// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"6bfdad41","204":"05b4e769","453":"1f960028","698":"ecca180a","708":"76e0c252","946":"4411fa31"}[chunkId] + ".chunk.js";
};